import styled, { keyframes } from 'styled-components';

import theme from '@/styles/theme';
import { withOpacity } from '@/utils/opacity';

const loading = keyframes`
  to {
    background-position-x: -20%;
  }
`;

export const StyledSkeleton = styled.div<{
  backgroundColor?: string;
  gradientColor?: string;
}>`
  border-radius: 5px;
  ${({ backgroundColor = theme.color.gray40, gradientColor = '#ffffff' }) => `
    background-color: ${backgroundColor};
    background: linear-gradient(
        120deg,
        ${withOpacity(gradientColor, '0%')} 40%,
        ${withOpacity(gradientColor, '50%')} 50%,
        ${withOpacity(gradientColor, '0%')} 60%
      )
      ${backgroundColor};
  `}
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1.6s ${loading} ease-in-out infinite;
`;
